@for (item of totals; track item; let first = $first) {
@if(!onlyTotal || item.id === 'total'){

<div class="flex flex-justify-between col-1"
     [class.m-t]="!first && !onlyTotal && item.id === 'total'"
     [class.s1]="item.id === 'total'"
     [class.col-3]="item.id === 'discount'"
     [class]="item.id !== 'total' ? 'p1 m-t-2' : onlyTotal ? 's1' : 's1 m-t-3 b-t p-t-3 b-col-4'">
    <span class="flex flex-middle">
        <label class="m-r-2">{{item.label | translate}}</label>
        @if(item.id === 'discount'){
        <button class="col-1"
                [inlineButton]
                type="button"
                (click)="removeCoupon()"
                [status]="removeStatus"><span class="s2"
                  style="letter-spacing: 0;">{{'Remove' | translate}}</span></button>
        }
    </span>
    <price class="price"
           [useFreeLabel]="true"
           [precision]="2"
           [value]="item.value"></price>
</div>
}
}